import Model from "@/lib/model/model";
import ViConfig from "@/lib/model/user/config";
import request from "@/lib/request/request";

import Path from "@/lib/common/path";
import Config from "@/config/config";

export default class User extends Model {
  id = "";
  username = "";
  mobile = "";
  email = "";
  password = "";
  nickname = "";
  realname = "";
  avatarUrl = "";
  gender = 0;
  birthday = "";
  threatDegree = "30";
  viConfig: ViConfig = new ViConfig();

  public static info(autoHandleError = true) {
    return request
      .post(
        Path.join(Config.apiUrl, "interview/user/getUserNew"),
        {},
        autoHandleError
      )
      .then(resp => {
        const user = new User(resp).assign(resp.data.data);
        const vuexStore = import("@/store/vuex-store");
        vuexStore.then(module => {
          module.default.updateUser(user);
        });
        return user;
      });
  }
}
